
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
// @ actions
const { setCollectiveUserPromptNotification, setUnreadNotificationsCount } = require('actions/userNotifications');

const collectiveSendNotificationRequest = () => ({ type: actionTypes.COLLECTIVE_SEND_NOTIFICATION_REQUEST });

const collectiveSendNotificationSuccess = (response) => ({
    type: actionTypes.COLLECTIVE_SEND_NOTIFICATION_SUCCESS,
    payload: {
        response
    }
});

const collectiveSendNotificationFailure = (error) => ({
    type: actionTypes.COLLECTIVE_SEND_NOTIFICATION_FAILURE,
    payload: { error }
});

const collectiveBannerStatusRequest = () => ({ type: actionTypes.COLLECTIVE_BANNER_STATUS_REQUEST });

const collectiveBannerStatusSuccess = (response) => ({
    type: actionTypes.COLLECTIVE_BANNER_STATUS_SUCCESS,
    payload: {
        response
    }
});

const collectiveBannerStatusFailure = (error) => ({
    type: actionTypes.COLLECTIVE_BANNER_STATUS_FAILURE,
    payload: { error }
});

const getCollectivesBannerStatus = () => (dispatch, getState) => {
    const isFetching = getState().collectivesNotification.get('isStatusFetching');
    const error = getState().collectivesNotification.get('statusError');

    if (!isFetching && !error) {
        dispatch(collectiveBannerStatusRequest());
        APIGet({dispatch, endpoint: 'collectivesBannerStatus', params: {}}
        ).then((response)=> {
            dispatch(collectiveBannerStatusSuccess(response));
            dispatch(setCollectiveUserPromptNotification(response));
        }).catch((error) => {
            dispatch(collectiveBannerStatusFailure(error));
        });
    }

}

const sendCollectivesNotification = (promoCode, company) => (dispatch, getState) => {
    const isFetching = getState().collectivesNotification.get('isNotificationFetching');
    const error = getState().collectivesNotification.get('notificationError');

    if (!isFetching && !error) {
        const data = {
            query: {
                promoCode,
                company
            }
        };

        dispatch(collectiveSendNotificationRequest());
        APIPost({dispatch, endpoint: 'collectivesSendNotification', params: data}
        ).then((response)=> {
            dispatch(collectiveSendNotificationSuccess(response));
            response.refreshNotification && dispatch(setUnreadNotificationsCount());
            dispatch(getCollectivesBannerStatus());
        }).catch((error) => {
            dispatch(collectiveSendNotificationFailure(error));
            dispatch(getCollectivesBannerStatus());
        });
    }

}

module.exports = {
    getCollectivesBannerStatus,
    sendCollectivesNotification
}

